<div class="period-dropdown" [class.open]="isOpen">
  <!-- Mobile Backdrop Overlay -->
  <div class="mobile-backdrop" *ngIf="isOpen" (click)="onCancel()"></div>

  <button class="period-dropdown-trigger" (click)="onToggle()">
    <span class="period-dropdown-text">{{ getSelectedLabel() }}</span>
    <svg class="period-dropdown-arrow" width="12" height="8" viewBox="0 0 12 8" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1.5L6 6.5L11 1.5" stroke="#15172E" stroke-width="1.5" stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  </button>

  <div class="period-dropdown-menu" *ngIf="isOpen">
    <div class="period-dropdown-header">
      <h3 class="period-dropdown-title">Date</h3>
    </div>

    <div class="period-dropdown-content">
      <div class="period-options">
        <label class="period-option" *ngFor="let option of options; trackBy: trackByValue">
          <input type="radio" name="period" [value]="option.id" [checked]="tempSelectedPeriod === option.id"
            (change)="onSelectOption(option.id)" class="period-radio">
          <div class="custom-radio" [class.selected]="tempSelectedPeriod === option.id">
            <div class="radio-inner" *ngIf="tempSelectedPeriod === option.id"></div>
          </div>
          <span class="period-option-label" [class.selected]="tempSelectedPeriod === option.id">{{ option.label
            }}</span>
        </label>
      </div>

      <!-- Custom Week Calendar -->
      <div class="custom-week-section" *ngIf="tempSelectedPeriod === 'custom'">
        <div class="week-input-wrapper" (click)="toggleWeekCalendar(); $event.stopPropagation()">
          <div class="week-display-input">
            <span class="week-text">{{ customWeekData ? customWeekData.weekRange : 'Select a week' }}</span>
            <svg class="calendar-icon" width="15" height="14" viewBox="0 0 15 14" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.5 2H3.5C2.94772 2 2.5 2.44772 2.5 3V11C2.5 11.5523 2.94772 12 3.5 12H11.5C12.0523 12 12.5 11.5523 12.5 11V3C12.5 2.44772 12.0523 2 11.5 2Z"
                stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M9.5 1V3" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M5.5 1V3" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M2.5 5H12.5" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>
        </div>

        <!-- Week Calendar Dropdown -->
        <div class="week-calendar-dropdown" *ngIf="showWeekCalendar" (click)="$event.stopPropagation()">
          <div class="calendar-header">
            <button class="calendar-nav-button" (click)="navigateMonth('prev'); $event.stopPropagation()" type="button">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M10.4 1L3.6 7L10.4 13" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </button>
            <span class="month-year">{{ getCurrentMonthYear() }}</span>
            <button class="calendar-nav-button" (click)="navigateMonth('next'); $event.stopPropagation()" type="button">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M3.6 1L10.4 7L3.6 13" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </button>
          </div>

          <div class="calendar-grid">
            <div class="day-header" *ngFor="let day of dayHeaders; trackBy: trackByIndex">{{ day }}</div>
            <div class="calendar-day" *ngFor="let day of getCalendarDays(); trackBy: trackByIndex" [class.other-month]="day.isOtherMonth"
              [class.selected-week]="isDayInSelectedWeek(day.date)" [class.today]="isToday(day.date)"
              (click)="selectWeek(day.date); $event.stopPropagation()">
              {{ day.day }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="period-dropdown-footer">
      <button class="period-clear-link" *ngIf="showClear" (click)="onClear()">
        {{ clearText }}
      </button>
      <div class="period-footer-buttons">
        <button class="period-btn period-btn-cancel" (click)="onCancel()">
          {{ secondaryButtonText }}
        </button>
        <button class="period-btn period-btn-apply" (click)="onApply()" [disabled]="isApplyDisabled()">
          {{ primaryButtonText }}
        </button>
      </div>
    </div>
  </div>
</div>